export enum MarkdownAtomType {
    SUB_BLOCK = 'SUB_BLOCK',
    PLAIN = 'PLAIN',
    BOLD = 'BOLD',
    ITALIC = 'ITALIC',
    BOLD_ITALIC = 'BOLD_ITALIC',
    CHECKBOX = 'CHECKBOX',
    LINK = 'LINK',
    CODE = 'CODE',
    LINE_THROUGH = 'LINE_THROUGH'
}

export interface MarkdownAtom {
    columnNo: number
    posNo: number
    id: string
    type: MarkdownAtomType
    subAtoms: Array<MarkdownAtom>
    checked: boolean
    content: string
    url: string
    indent: number
}

export enum BlockType {
    HEADER_1 = 'HEADER_1',
    HEADER_2 = 'HEADER_2',
    HEADER_3 = 'HEADER_3',
    HEADER_4 = 'HEADER_4',
    HEADER_5 = 'HEADER_5',
    HEADER_6 = 'HEADER_6',
    PARAGRAPH = 'PARAGRAPH',
    QUOTE = 'QUOTE',
    CODE = 'CODE',
    ORDERED_LIST = 'ORDERED_LIST',
    UNORDERED_LIST = 'UNORDERED_LIST',
    TABLE = 'TABLE',
}

export interface MarkdownBlock {
    lineNo: number
    posNo: number
    id: string
    type: BlockType
    atoms: Array<MarkdownAtom>
    startFrom: number
    hint: string
    indent: number
}

export interface MarkdownText {
    blocks: Array<MarkdownBlock>
}
